import { endSession } from '../firebase.js'

/**
 * Signed in successfully, but the database rules rejected the read — i.e. this
 * Google account is not the allowlisted one.
 *
 * Distinguishing this from "not signed in" matters: the fix is to sign in as a
 * different account, and a plain sign-in button would just loop them back into
 * the same rejected session, since Google would silently reuse it.
 */
export default function AccessGate({ user }) {
  return (
    <main className="setup">
      <h1>Wingfinder</h1>
      <p>This account isn't authorized.</p>
      <p className="muted">
        You're signed in as <strong>{user?.email || 'an unknown account'}</strong>, which the
        database rules don't allow. Sign out and try the account this project was set up for.
      </p>
      <button className="google-btn" onClick={() => endSession()}>
        Sign out
      </button>
    </main>
  )
}
